import {ModalBody} from "@/components/modal/index";
import styled from "styled-components";
import {FileUploadArea, TitleContentInner, TitleContentWrap} from "@/styles/CommonStyle";
import {observer} from "mobx-react";
import moment from "moment/moment";
import {useStore} from "@/store";
import React, {useEffect} from "react";
import {downloadFile, fileUpload} from "@/utils";
import Input from "@/components/common/Input";
import {BsPaperclip} from "react-icons/bs";
import {IoCloseCircleOutline} from "react-icons/io5";


const FormDetailModal = observer(({data}) => {
    const {boardDetailStore} = useStore();
    return(
        <ModalBody>
            <FormDetailModalWrap>
                <TitleContentWrap>
                    <TitleContentInner>
                        <div className={"title"}>작성일</div>
                        <div className={"content"}>{moment(data.createdAt).format("YYYY-MM-DD")}</div>
                    </TitleContentInner>
                    {
                        boardDetailStore.setFormDetailOrder(data) && boardDetailStore.setFormDetailOrder(data).length > 0 &&
                        boardDetailStore.setFormDetailOrder(data).map((item, idx) =>
                            <TitleContentInner key={idx}>
                                <div className={"title"}>{item.name}</div>
                                <div className={"content pre-line"}>{item.value}</div>
                            </TitleContentInner>
                        )
                    }
                    <TitleContentInner>
                        <div className={"title"}>파일</div>
                        <div className={"content"}>
                            <FileUploadArea>
                                {
                                    data.files && data.files.length > 0 ? (
                                    <div className={"file-list-info"}>
                                        {data.files.map((item, idx) => (
                                            <div className={"file-item-wrap"} key={idx}>
                                                <div
                                                    className={"file-item-name"}
                                                    onClick={async () => {
                                                        let file = item;
                                                        if (typeof item === "string") {
                                                            file = JSON.parse(item);
                                                        }
                                                        const url = file.path;
                                                        if (!url) return;
                                                        const name = file.name || "";
                                                        const targetForCheck = (name || url).toLowerCase();
                                                        const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(targetForCheck);
                                                        const isPdf = /\.pdf$/.test(targetForCheck);
                                                        if (isImage || isPdf) {
                                                            // 이미지 또는 PDF → 새창 열기
                                                            window.open(url, "_blank", "noopener,noreferrer");
                                                        } else {
                                                            await downloadFile(file.path, file.name);
                                                        }
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            </div>
                                        ))}
                                    </div>)
                                        :
                                        <>-</>
                                }
                            </FileUploadArea>
                        </div>
                    </TitleContentInner>
                </TitleContentWrap>
            </FormDetailModalWrap>
        </ModalBody>
    )
})

const FormDetailModalWrap = styled.div`
    .pre-line {
        white-space: pre-line;
    }

    .file-list-info {
        margin-top: 0;
    }

    .file-item-wrap {
        cursor: pointer;
    }
`
export default FormDetailModal